import React, { useEffect, useRef } from 'react';
import { useFilesUploadStore } from 'src/common/store/files-upload.store';
import { OnboardingGuideHost } from 'src/onboarding/components/guide/host';
import { useUserOnboardingStore } from 'src/onboarding/store/user-onboarding.store';
import { functionNoop } from 'src/utils/function/noop';
import { usePreviousValue } from 'src/utils/react/previous-value.hook';
import { DashboardLibraryContentUploadBubbleItem } from './upload-bubble-item';

export const DashboardLibraryContentUploadBubble = () => {
  const notificationMarginCalculatorRef = useRef(functionNoop);
  const { getOngoingUploadStacks, stackLength } = useFilesUploadStore();
  const { isOnboardingShown, open } = useUserOnboardingStore();
  const isOnboardingRendered = isOnboardingShown();
  const previousStackLength = usePreviousValue(stackLength);

  useEffect(() => {
    if (open && previousStackLength && stackLength !== previousStackLength) {
      notificationMarginCalculatorRef.current();
    }
  }, [stackLength, open, previousStackLength]);

  const ongoingUploads = getOngoingUploadStacks();

  if (!ongoingUploads.length || isOnboardingRendered) {
    return null;
  }

  return (
    <OnboardingGuideHost
      show
      notificationMarginCalculatorRef={notificationMarginCalculatorRef}
      remainingCount={ongoingUploads.length}
      content={
        <div className='flex flex-col gap-2'>
          {ongoingUploads.map(([name, stack]) => (
            <DashboardLibraryContentUploadBubbleItem key={`item-${name}`} name={name} stack={stack} />
          ))}
        </div>
      }
    />
  );
};
